/* eslint-disable import/first, import/newline-after-import */

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import PartnerJustifiedSearchController from 'components/partner/search/justified-search/partner-justified-search-controller';
EezyStimulusApplication.register('partner-justified-search', PartnerJustifiedSearchController);

import PartnerSponsoredResultsController from 'components/partner/search/sponsored-results/sponsored-results-controller';
EezyStimulusApplication.register('partner-sponsored-results', PartnerSponsoredResultsController);
